import "../../styles/Challenges.css";
import { useState } from "react";
import { ReactComponent as PlusIcon } from "../../images/plus.svg";
import { useData } from "../../providers/ContextProvider";

const initialChallenge = {
  name: "",
  dateCreated: "",
  dateEnded: "",
  coinsBet: 20,
  isSelfChallenge: true,
  creator: "",
  creatorName: "",
  participants: [],
  participantResults: [],
  status: "",
  description: "",
};
function Challenge({ challenge }) {
  const [isDisabled, setIsDisabled] = useState(false);
  const { state, dispatch } = useData();
  const { challenges, userID } = state;

  function joinChallenge(challengeID, userID, coinsBet) {
    console.log("here!");
    dispatch({
      type: "JOIN_CHALLENGE",
      payload: { challengeID, userID, coinsBet },
    });
    setIsDisabled(true);
  }

  console.log({ isDisabled });

  return (
    <div className="challenge-card" key={challenge.id}>
      <div className="challenge-type">
        {challenge.isSelfChallenge ? "Self" : "Group"}
      </div>
      <div className="challenge-header">
        <div className="challenge-name">{challenge.name} </div>
        <div className={`challenge-status ${challenge.status}`}>
          {challenge.status.toUpperCase()}
        </div>
      </div>
      <div className="challenge-creator">{challenge.creatorName}</div>
      <div className="challenge-coins">Bet {challenge.coinsBet} to win!</div>
      <div className="challenge-description">{challenge.description}</div>
      {challenge.status === "ongoing" ? (
        !isDisabled ? (
          <button
            className="btn btn-fill-light challenge-btn"
            onClick={() =>
              joinChallenge(challenge.id, userID, challenge.coinsBet)
            }
          >
            JOIN
          </button>
        ) : (
          <button className="btn btn-fill-light challenge-btn" disabled>
            JOINED
          </button>
        )
      ) : (
        ""
      )}
    </div>
  );
}

function Challenges() {
  const [isModalOpen, toggleModal] = useState(false);
  const [newChallenge, createChallenge] = useState(initialChallenge);
  const [viewSelfChallenges, toggleViewSelfChallenges] = useState(true);

  const { state, dispatch } = useData();
  const { challenges, userID } = state;

  function createNewChallenge() {
    toggleModal((isModalOpen) => !isModalOpen);
  }

  return (
    <main className="main challenge-main">
      <div className="challenges-container">
        {/* <button
          className="btn btn-outline btn-challenges"
          onSubmit={createNewChallenge}
        >
          <PlusIcon /> CREATE
        </button> */}
        {/* <div className="challenges-btn-group">
          <button className="btn" onSubmit={toggleViewSelfChallenges}>
            Self Challenges
          </button>
          <button className="btn" onSubmit={toggleViewSelfChallenges}>
            Group Challenges
          </button>
        </div> */}
        {console.log({ challenges })}
        {challenges.map((challenge) => (
          <Challenge challenge={challenge} key={challenge.id} />
        ))}
      </div>
    </main>
  );
}

export default Challenges;
